import React, { useState, useEffect } from "react";
import { Form, FormField, Button, Dropdown, Icon } from "semantic-ui-react";
import { APICall } from "../api";
import { showNotification } from "../utils/notifications";

const opzioniSesso = [
  { key: "n", value: "n", text: "Tutti" },
  { key: "m", value: "m", text: "Maschio" },
  { key: "f", value: "f", text: "Femmina" },
];

export default function FormInserimento({ onInsertSuccess }) {
  const [formData, setFormData] = useState({
    data_consegna: null,
    codice: "",
    qualifica: "",
    nazionalita: "",
    cognome: "",
    nome: "",
    sesso: "",
    telefono: "",
    citta: "",
    provincia: "",
    cap: "",
    coordinate: "",
    zona: "",
    asl: "",
    municipi_distretti_roma: "",
    email: "",
    patente: "",
    turni_accessi: "",
    data_colloquio_contatto: null,
    offerta_assistenza: "",
    tipo_collaborazione: "",
    commenti: "",
    utente_primo_caricamento: "",
  });

  const [cognomeCheckTimer, setCognomeCheckTimer] = useState(null);
  const [fieldErrors, setFieldErrors] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const ToggleForm = () => {
    setIsOpen(!isOpen);
  };

  // reset the state to reset the form input fields
  const resetForm = () => {
    const resetData = {};
    for (const key in formData) {
      // Imposta i campi data a null invece di stringa vuota
      if (key === "data_consegna" || key === "data_colloquio_contatto") {
        resetData[key] = null;
      } else {
        resetData[key] = "";
      }
    }
    setFormData(resetData);

    // reset timer del controllo del cognome
    if (cognomeCheckTimer) {
      clearTimeout(cognomeCheckTimer);
      setCognomeCheckTimer(null);
    }
  };

  // Funzione per controllare se esiste già un operatore con lo stesso cognome
  const checkCognome = async (cognome) => {
    console.log("funzione checkCognome chiamata con: ", cognome);
    if (!cognome || cognome.length < 3) {
      return;
    }
    // facciamo la chiamata e codifichiamo la stringa affinché non produca errori con apostrofi, spazi e simili
    try {
      const response = await APICall.get(
        `/check-cognome/${encodeURIComponent(cognome)}`
      );

      if (response.data.success && response.data.exists) {
        const matches = response.data.matches;
        const matchList = matches
          .map(
            (match) =>
              `- ID: ${match.id} Nome: ${match.nome} Cognome: ${
                match.cognome
              } ${match.citta ? ` Città ${match.citta}` : ""}`
          )
          .join("\n");

        showNotification(
          `
            ⚠️ Attenzione: Esistono già ${matches.length} con questo cognome:\n${matchList}\n\nVuoi continuare comunque?`,
          true, // solo un avviso invece che un errore
          8000
        );
      }
    } catch (error) {
      console.error(
        "Errore durante il controllo dei duplicati nel cognome:",
        error
      );
    }
  };

  // Controllo cognome in tempo reale con debounce
  useEffect(() => {
    // reset timer precedente
    if (cognomeCheckTimer) {
      clearTimeout(cognomeCheckTimer);
    }

    // se il cognome ha almeno 3 caratteri avvia il controllo con debounce (500ms)
    if (formData.cognome && formData.cognome.length >= 3) {
      const timer = setTimeout(() => {
        checkCognome(formData.cognome);
      }, 500);
      setCognomeCheckTimer(timer);
    }

    // reset del timer quando il cognome cambia o si smonta il componente
    return () => {
      if (cognomeCheckTimer) {
        clearTimeout(cognomeCheckTimer);
      }
    };
  }, [formData.cognome]); // viene chiamato ogni volta che il cognome cambia

  const handleChange = (e, data) => {
    const { name, value } = data || e.target;

    // rimuovi l'errore quando l'utente inizia a digitare nel form
    if (fieldErrors[name]) {
      setFieldErrors({ ...fieldErrors, [name]: false });
    }

    // Gestione speciale per i campi data
    if (name === "data_consegna" || name === "data_colloquio_contatto") {
      // Se il valore è una stringa vuota, imposta a null
      setFormData({ ...formData, [name]: value === "" ? null : value });
    } else {
      setFormData({ ...formData, [name]: value || null });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // reset errori precedenti
    setFieldErrors({});

    // verifica campi obbligatori
    const requiredFields = {
      cognome: "Cognome",
      nome: "Nome",
      codice: "Codice Professione",
      telefono: "Telefono",
      citta: "Città",
      provincia: "Provincia",
      cap: "CAP",
      asl: "ASL",
    };
    const errors = {};
    const missingFields = [];

    Object.keys(requiredFields).forEach((field) => {
      if (!formData[field]) {
        errors[field] = true;
        missingFields.push(requiredFields[field]);
      }
    });

    if (missingFields.length > 0) {
      setFieldErrors(errors);
      showNotification(
        `Inserisci i seguenti campi obbligatori: ${missingFields.join(", ")}.`,
        true
      );
      return;
    }

    // get user email from token to record the user who firstly created the record
    const token = localStorage.getItem("auth_token");
    if (token) {
      try {
        const base64Url = token.split(".")[1];
        const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        const payload = JSON.parse(window.atob(base64));
        const userEmail = payload.email;

        const updatedData = {
          ...formData,
          utente_primo_caricamento: userEmail,
        };
        console.log("Token decodificato in fase di caricamento:", payload);
        console.log("Email utente primo caricamento:", userEmail);
        const response = await APICall.post("/inserimento", updatedData, {
          headers: {
            "Content-Type": "application/json",
          },
        });

        console.log("I dati di response sono i seguenti:", response);
        if (response.status >= 200 && response.status < 300) {
          showNotification("Operatore inserito correttamente.");
          console.log(
            "I dati del form inviati al server sono i seguenti:",
            formData
          );
          onInsertSuccess(); // reload table with updated data
          resetForm(); // clean form fields
        } else {
          throw new Error(
            `Errore del server: ${response.status}. - Messaggio della risposta: ${response.statusText}. - Dati della risposta: ${response.data}`
          );
        }
      } catch (error) {
        console.error("Messaggio di errore:", error.message);
        console.error("Report errore completo:", error);
        console.error("Dettagli dell'errore:", error.response.data.error);
        showNotification(
          error.message ||
            "Si è verificato un errore nell'inserimento dell'operatore",
          true
        );
      }
    }
  };

  return (
    <div className="insert-form-container">
      <button onClick={ToggleForm} className="form-inserimento-button">
        <h2 className="subtitle">Form Inserimento Operatore</h2>
        {isOpen ? <Icon name="chevron down" /> : <Icon name="chevron up" />}
      </button>
      <Form
        className={`insert-form ${isOpen ? "form-open" : "form-closed"}`}
        onSubmit={handleSubmit}
      >
        <FormField>
          <label>Data Consegna</label>
          <div className="date-input-tooltip">
            <input
              type="date"
              name="data_consegna"
              value={formData.data_consegna}
              onChange={handleChange}
            />
            <span className="tooltip-text">Data Consegna</span>
          </div>
        </FormField>
        <FormField>
          <Dropdown
            search
            selection
            clearable
            placeholder="Codice"
            name="codice"
            options={[
              { key: "acc", value: "ACC", text: "ACC" },
              { key: "altro", value: "ALTRO", text: "ALTRO" },
              { key: "ammva", value: "AMMVA", text: "AMMVA" },
              { key: "assdom", value: "ASSDOM", text: "ASSDOM" },
              { key: "assfam", value: "ASSFAM", text: "ASSFAM" },
              { key: "asssoc", value: "ASSSOC", text: "ASSSOC" },
              { key: "aus", value: "AUS", text: "AUS" },
              { key: "bad", value: "BAD", text: "BAD" },
              { key: "bio", value: "BIO", text: "BIO" },
              { key: "cuo", value: "CUO", text: "CUO" },
              { key: "die", value: "DIE", text: "DIE" },
              { key: "edu", value: "EDU", text: "EDU" },
              { key: "fsk", value: "FSK", text: "FSK" },
              { key: "igi", value: "IGI", text: "IGI" },
              { key: "inf", value: "INF", text: "INF" },
              { key: "ins", value: "INS", text: "INS" },
              { key: "log", value: "LOG", text: "LOG" },
              { key: "med", value: "MED", text: "MED" },
              { key: "neu", value: "NEU", text: "NEU" },
              { key: "oepac", value: "OEPAC", text: "OEPAC" },
              { key: "ope", value: "OPE", text: "OPE" },
              { key: "ort", value: "ORT", text: "ORT" },
              { key: "osa", value: "OSA", text: "OSA" },
              { key: "oss", value: "OSS", text: "OSS" },
              { key: "osss", value: "OSSS", text: "OSSS" },
              { key: "ost", value: "OST", text: "OST" },
              { key: "ota", value: "OTA", text: "OTA" },
              { key: "pod", value: "POD", text: "POD" },
              { key: "psi", value: "PSI", text: "PSI" },
              { key: "tec", value: "TEC", text: "TEC" },
              { key: "terocc", value: "TEROCC", text: "TEROCC" },
              { key: "tnpee", value: "TNPEE", text: "TNPEE" },
            ]}
            value={formData.codice}
            onChange={handleChange}
            style={
              fieldErrors.codice
                ? { borderColor: "red", borderWidth: "2px" }
                : {}
            }
          />
        </FormField>
        <FormField>
          <label>Qualifica</label>
          <input
            type="text"
            placeholder="Qualifica"
            name="qualifica"
            value={formData.qualifica}
            onChange={handleChange}
          />
        </FormField>
        <FormField>
          <label>Nazionalità</label>
          <input
            type="text"
            placeholder="Nazionalita"
            name="nazionalita"
            value={formData.nazionalita}
            onChange={handleChange}
          />
        </FormField>
        <FormField>
          <label>Cognome</label>
          <input
            type="text"
            placeholder="Cognome"
            name="cognome"
            value={formData.cognome}
            onChange={handleChange}
            style={
              fieldErrors.cognome
                ? { borderColor: "red", borderWidth: "2px" }
                : {}
            }
          />
        </FormField>
        <FormField>
          <label>Nome</label>
          <input
            type="text"
            placeholder="Nome"
            name="nome"
            value={formData.nome}
            onChange={handleChange}
            style={
              fieldErrors.nome ? { borderColor: "red", borderWidth: "2px" } : {}
            }
          />
        </FormField>
        <FormField>
          <label>Sesso</label>
          <Dropdown
            selection
            placeholder="Sesso"
            options={opzioniSesso}
            name="sesso"
            value={formData.sesso}
            onChange={handleChange}
            className="dropdown-sesso"
          ></Dropdown>
        </FormField>
        <FormField>
          <label>Telefono</label>
          <input
            type="tel"
            placeholder="Telefono"
            name="telefono"
            value={formData.telefono}
            onChange={handleChange}
            style={
              fieldErrors.telefono
                ? { borderColor: "red", borderWidth: "2px" }
                : {}
            }
          />
        </FormField>
        <FormField>
          <label>Citta</label>
          <input
            type="text"
            placeholder="Citta"
            name="citta"
            value={formData.citta}
            onChange={handleChange}
            style={
              fieldErrors.citta
                ? { borderColor: "red", borderWidth: "2px" }
                : {}
            }
          />
        </FormField>
        <FormField>
          <label>Provincia</label>
          <input
            type="text"
            placeholder="Provincia"
            name="provincia"
            value={formData.provincia}
            onChange={handleChange}
            style={
              fieldErrors.provincia
                ? { borderColor: "red", borderWidth: "2px" }
                : {}
            }
          />
        </FormField>
        <FormField>
          <label>Cap</label>
          <input
            type="number"
            placeholder="Cap"
            name="cap"
            value={formData.cap}
            onChange={handleChange}
            style={
              fieldErrors.cap ? { borderColor: "red", borderWidth: "2px" } : {}
            }
          />
        </FormField>
        <FormField>
          <label>Coordinate</label>
          <input
            type="text"
            placeholder="Coordinate"
            name="coordinate"
            value={formData.coordinate}
            onChange={handleChange}
          />
        </FormField>
        <FormField>
          <label>Zona</label>
          <input
            type="text"
            placeholder="Zona"
            name="zona"
            value={formData.zona}
            onChange={handleChange}
          />
        </FormField>
        <FormField>
          <label>ASL</label>
          <input
            type="text"
            placeholder="ASL"
            name="asl"
            value={formData.asl}
            onChange={handleChange}
            style={
              fieldErrors.asl ? { borderColor: "red", borderWidth: "2px" } : {}
            }
          />
        </FormField>
        <FormField>
          <label>Municipi/Distretti Roma</label>
          <input
            type="text"
            placeholder="Munic."
            name="municipi_distretti_roma"
            value={formData.municipi_distretti_roma}
            onChange={handleChange}
          />
        </FormField>
        <FormField>
          <label>Email</label>
          <input
            type="email"
            placeholder="Email"
            name="email"
            value={formData.email}
            onChange={handleChange}
          />
        </FormField>
        <FormField>
          <label>Patente</label>
          <Dropdown
            selection
            clearable
            upward
            placeholder="Patente"
            name="patente"
            options={[
              { key: "si", value: "SI", text: "SI" },
              { key: "no", value: "NO", text: "NO" },
            ]}
            value={formData.patente}
            onChange={handleChange}
          />
        </FormField>
        <FormField>
          <label>Disponibilità</label>
          <Dropdown
            selection
            search
            clearable
            upward
            placeholder="Disponibilità"
            name="turni_accessi"
            options={[
              { key: "contattare", value: "CONTATTARE", text: "CONTATTARE" },
              { key: "diurno", value: "DIURNO", text: "DIURNO" },
              { key: "h24", value: "H24", text: "H24" },
              { key: "mattino", value: "MATTINO", text: "MATTINO" },
              { key: "nessuna", value: "NESSUNA", text: "NESSUNA" },
              { key: "notti", value: "NOTTI", text: "NOTTI" },
              { key: "pomeriggio", value: "POMERIGGIO", text: "POMERIGGIO" },
              { key: "posticipare", value: "POSTICIPARE", text: "POSTICIPARE" },
              {
                key: "ricontattabile",
                value: "RICONTATTABILE",
                text: "RICONTATTABILE",
              },
              { key: "totale", value: "TOTALE", text: "TOTALE" },
              { key: "turni", value: "TURNI", text: "TURNI" },
              { key: "valutare", value: "VALUTARE", text: "VALUTARE" },
              { key: "weekend", value: "WEEKEND", text: "WEEKEND" },
            ]}
            value={formData.turni_accessi}
            onChange={handleChange}
          />
        </FormField>
        <FormField>
          <label>Data Colloquio Contatto</label>
          <div className="date-input-tooltip">
            <input
              type="date"
              name="data_colloquio_contatto"
              value={formData.data_colloquio_contatto}
              onChange={handleChange}
            />
            <span className="tooltip-text">Data Colloquio Contatto</span>
          </div>
        </FormField>
        <FormField>
          <label>Offerta Assistenza</label>
          <input
            type="text"
            placeholder="Offerta Assistenza"
            name="offerta_assistenza"
            value={formData.offerta_assistenza}
            onChange={handleChange}
          />
        </FormField>
        <FormField>
          <label>Tipo Collaborazione</label>
          <Dropdown
            search
            selection
            clearable
            upward
            placeholder="Tipo Collaborazione"
            options={[
              { key: "pub", value: "PUB", text: "PUB" },
              { key: "piva", value: "PIVA", text: "PIVA" },
              { key: "ccnl", value: "CCNL", text: "CCNL" },
              { key: "ass", value: "ASS", text: "ASS" },
              { key: "priv", value: "PRIV", text: "PRIV" },
              { key: "naspi", value: "NASPI", text: "NASPI" },
              { key: "col", value: "COL", text: "COL" },
            ]}
            name="tipo_collaborazione"
            value={formData.tipo_collaborazione}
            onChange={handleChange}
          />
        </FormField>
        <FormField>
          <label>Commenti</label>
          <textarea
            placeholder="Commenti"
            name="commenti"
            value={formData.commenti}
            onChange={handleChange}
            cols={48}
            rows={8}
            style={{ resize: "both" }}
          />
        </FormField>
        <FormField>
          <Button className="insert-button" type="submit">
            Inserisci
          </Button>
        </FormField>
      </Form>
    </div>
  );
}
